import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '@/utils/validators';
import Overlay from '@/forms/_common/Overlay';
import FormErrors from '@/forms/_common/FormErrors';
import RequestError from '@/forms/_common/RequestError';
import ErrorMessage from '@/forms/_common/ErrorMessage';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import Form from './Form';
import FindOrCreateOrganization from './FindOrCreateOrganization';
import { useQueryMutation } from '@lore/query-connect';
import { useUser } from '@lore/auth';

export default function CreateOrganizationDialog(props) {
  const { onCancel } = props;

  const user = useUser();

  const [data, setData] = useState({
    place_id: '',
    name: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    city: '',
    state: '',
    zipCode: '',
    title: '',
    type: ''
  });
  const [showErrors, setShowErrors] = useState(false);
  const [finished, setFinished] = useState(false);

  const mutation = useQueryMutation('job.create');
  const { saving, success, error, request } = mutation;

  const [place_id, setPlaceId] = useState(null);

  const [organizationRequest, setOrganizationRequest] = useState({
    request: undefined,
    saving: false,
    success: false,
    error: false
  });

  // prevents duplicate POSTs (including React 18 StrictMode dev behavior)
  const hasCreatedJobRef = useRef(false);

  useEffect(() => {
    if (organizationRequest && organizationRequest.success && !hasCreatedJobRef.current) {
      hasCreatedJobRef.current = true;
      mutation.mutate({
        userId: user.id,
        organizationId: organizationRequest.request.id,
        title: data.title
      });
    }
  }, [organizationRequest]);

  useEffect(() => {
    if (success && !finished) {
      setFinished(true);
      props.onCancel();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success, finished]);

  function onSubmit() {
    setPlaceId(data.place_id || data.name)
  }

  return (
    <DialogTemplate className="w-screen max-w-md">
      {place_id && (
        <FindOrCreateOrganization
          key={place_id}
          place_id={place_id}
          data={data}
          user={user}
          onSubmit={(result) => setOrganizationRequest(result)}
        />
      )}
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          name: [validators.isRequired],
          city: [validators.isRequired],
          state: [validators.isRequired],
          zipCode: [validators.isRequired],
          title: [validators.isRequired],
          type: [validators.isRequired]
        }}>
          {({ errors, hasError }) => (
            <Form
              user={user}
              data={data}
              errors={errors}
              showErrors={showErrors}
              onChange={(name, value) => {
                setData(_.merge({}, data, {
                  [name]: value
                }));
              }}
              onChangeMultiple={(values) => {
                // if (values.place_id) {
                //   findOrganization(values);
                // }
                setData(_.merge({}, data, values));
              }}
              onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
              onCancel={onCancel}
              alert={error ? (
                <RequestError request={request} />
              ) : showErrors ? (
                <ErrorMessage>
                  Please fill in all required fields.
                </ErrorMessage>
              ) : null}
            />
          )}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
}

CreateOrganizationDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func
};
